export type GuitarStatus = 'active' | 'on-loan' | 'for-sale' | 'archived';
export type GuitarType = 'Electric' | 'Acoustic' | 'Bass' | 'Classical';

export interface Guitar {
  id: string;
  brand: string;
  model: string;
  type: GuitarType;
  color: string;
  serialNumber: string;
  purchaseDate: string;
  purchaseLocation: string;
  purchasePrice: number;
  status: GuitarStatus;
  lastMaintenance: string;
  lastStringChange: string;
  notes: string;
  photoUrl: string;
}

export const mockGuitars: Guitar[] = [
  {
    id: 'guitar-001',
    brand: 'Gibson',
    model: '1959 Les Paul Standard Reissue',
    type: 'Electric',
    color: 'Lemon Burst',
    serialNumber: 'GIB-R9-2024-04821',
    purchaseDate: '04/28/2026',
    purchaseLocation: 'Vintage Guitar Emporium, Nashville',
    purchasePrice: 4200,
    status: 'active',
    lastMaintenance: '03/15/2026',
    lastStringChange: '04/10/2026',
    notes: 'Excellent fretwork, original PAF-style pickups. Light buckle rash on back.',
    photoUrl: '',
  },
  {
    id: 'guitar-002',
    brand: 'Fender',
    model: 'American Ultra Stratocaster',
    type: 'Electric',
    color: 'Ultraburst',
    serialNumber: 'US21-056-7841',
    purchaseDate: '03/12/2026',
    purchaseLocation: 'Guitar Center, Los Angeles',
    purchasePrice: 1799,
    status: 'active',
    lastMaintenance: '03/01/2026',
    lastStringChange: '03/20/2026',
    notes: 'Set up with 10s. Noise-less Gen 4 pickups are excellent.',
    photoUrl: '',
  },
  {
    id: 'guitar-003',
    brand: 'Martin',
    model: 'D-28 Authentic 1937',
    type: 'Acoustic',
    color: 'Aged Natural',
    serialNumber: 'MART-D28A-2023-1137',
    purchaseDate: '02/04/2026',
    purchaseLocation: 'Elderly Instruments, Lansing',
    purchasePrice: 3999,
    status: 'active',
    lastMaintenance: '01/20/2026',
    lastStringChange: '02/28/2026',
    notes: 'Adirondack spruce top. Incredible projection. Bone nut and saddle.',
    photoUrl: '',
  },
  {
    id: 'guitar-004',
    brand: 'PRS',
    model: 'Custom 24 Wood Library',
    type: 'Electric',
    color: 'Charcoal Burst',
    serialNumber: 'PRS-CW24-2025-8842',
    purchaseDate: '01/17/2026',
    purchaseLocation: 'PRS Dealer Direct, Stevensville',
    purchasePrice: 3100,
    status: 'on-loan',
    lastMaintenance: '12/10/2025',
    lastStringChange: '01/05/2026',
    notes: 'Loaned to Dmitri Volkov for studio session. Expected return Jun 2026.',
    photoUrl: '',
  },
  {
    id: 'guitar-005',
    brand: 'Taylor',
    model: "814ce Builder's Edition",
    type: 'Acoustic',
    color: 'Natural Top',
    serialNumber: 'TAYL-814-2024-20193',
    purchaseDate: '12/03/2025',
    purchaseLocation: "Sweetwater Sound, Fort Wayne",
    purchasePrice: 2199,
    status: 'active',
    lastMaintenance: '11/15/2025',
    lastStringChange: '12/20/2025',
    notes: 'V-Class bracing. Expression System 2 electronics. Excellent for live use.',
    photoUrl: '',
  },
  {
    id: 'guitar-006',
    brand: 'Gibson',
    model: '1959 Les Paul Junior',
    type: 'Electric',
    color: 'Cherry Red',
    serialNumber: 'GIB-LPJ-2020-00334',
    purchaseDate: '06/14/2020',
    purchaseLocation: 'eBay — private seller',
    purchasePrice: 1850,
    status: 'active',
    lastMaintenance: '11/02/2025',
    lastStringChange: '10/18/2025',
    notes: 'P-90 soapbar. Some playwear. Needs fret leveling soon.',
    photoUrl: '',
  },
  {
    id: 'guitar-007',
    brand: 'Fender',
    model: 'Player Stratocaster MIM',
    type: 'Electric',
    color: 'Polar White',
    serialNumber: 'MX-STRAT-2019-78421',
    purchaseDate: '03/22/2019',
    purchaseLocation: 'Guitar Center, Chicago',
    purchasePrice: 649,
    status: 'active',
    lastMaintenance: '10/30/2025',
    lastStringChange: '11/14/2025',
    notes: 'Modded with Lollar Specials. Blocking tremolo with brass block.',
    photoUrl: '',
  },
  {
    id: 'guitar-008',
    brand: 'Gibson',
    model: 'SG Special 1966 Reissue',
    type: 'Electric',
    color: 'Faded Pelham Blue',
    serialNumber: 'GIB-SG66-2022-11940',
    purchaseDate: '09/08/2022',
    purchaseLocation: 'Reverb.com — GuitarShopDE',
    purchasePrice: 1640,
    status: 'active',
    lastMaintenance: '12/05/2025',
    lastStringChange: '01/22/2026',
    notes: 'P-90s. Lightweight mahogany body. Great low-action setup.',
    photoUrl: '',
  },
  {
    id: 'guitar-009',
    brand: 'PRS',
    model: 'SE Custom 24',
    type: 'Electric',
    color: 'Trampas Green',
    serialNumber: 'PRS-SE24-2023-54421',
    purchaseDate: '05/19/2023',
    purchaseLocation: 'Guitar Center, Houston',
    purchasePrice: 849,
    status: 'for-sale',
    lastMaintenance: '02/11/2026',
    lastStringChange: '02/25/2026',
    notes: 'Listed at $950. Excellent condition. Minor ding on headstock.',
    photoUrl: '',
  },
  {
    id: 'guitar-010',
    brand: 'Ibanez',
    model: 'RG550 Genesis Collection',
    type: 'Electric',
    color: 'Desert Sun Yellow',
    serialNumber: 'IBZ-RG550G-2021-33317',
    purchaseDate: '11/30/2021',
    purchaseLocation: 'Sweetwater Sound, Fort Wayne',
    purchasePrice: 999,
    status: 'active',
    lastMaintenance: '03/28/2026',
    lastStringChange: '04/02/2026',
    notes: 'Edge tremolo, DiMarzio Evolution pickups. Neck is fast and low.',
    photoUrl: '',
  },
  {
    id: 'guitar-011',
    brand: 'Gretsch',
    model: 'G6120T-59 Vintage Select',
    type: 'Electric',
    color: 'Western Orange Stain',
    serialNumber: 'GRT-6120-2024-08812',
    purchaseDate: '08/15/2024',
    purchaseLocation: 'Norm\'s Rare Guitars, Tarzana',
    purchasePrice: 2499,
    status: 'active',
    lastMaintenance: '04/01/2026',
    lastStringChange: '04/15/2026',
    notes: "TV Jones Classics. Bigsby B6. Beautiful orange burst. Very Chet.",
    photoUrl: '',
  },
  {
    id: 'guitar-012',
    brand: 'Martin',
    model: '000-15M StreetMaster',
    type: 'Acoustic',
    color: 'Satin Mahogany',
    serialNumber: 'MART-000-2023-44019',
    purchaseDate: '07/22/2023',
    purchaseLocation: 'Guitar World, Austin',
    purchasePrice: 699,
    status: 'archived',
    lastMaintenance: '06/10/2025',
    lastStringChange: '06/10/2025',
    notes: 'Archived after neck reset. Kept for parts / historical record.',
    photoUrl: '',
  },
];